<template>
  <div class="page-dialog">
    <el-form
      label-width="90px"
      label-position="right"
      :inline="true"
      size="small"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="卖场简称">
            <el-input v-model="conditions.shortName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="卖场全称">
            <el-input v-model="conditions.fullName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tr">
        <el-button type="default" size="small" icon="el-icon-refresh-right" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="small" :loading="loading" icon="el-icon-search" @click="queryData(1)">查询</el-button>
      </el-row>
    </el-form>
    <div class="table-container">
      <TableCommon
        :custome-config="() => vxeShowCustom('gridOptions')"
        :show-header="false"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="medium"
          empty-text="暂时没数据"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiKastoreList } from '@/api/applyForGoods/goods-ka'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

// 接口入口
export default {
  props: {
    info: {
      type: Object,
      default: () => null
    },
    mode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDialogType: '',
      showDialog: false,
      dialogTitle: '',
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      selectDataOptions: {},
      conditions: {
        shortName: '',
        fullName: ''
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 50 },
          { field: 'shortName', title: 'KA卖场简称' },
          { field: 'fullName', title: 'KA卖场全称' },
          { field: 'brand', title: '所属品牌' }
        ],
        data: []
      }
    }
  },
  computed: {},
  methods: {
    cellClick({ row }) {
      this.$refs.gridOptions.setRadioRow(row)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 查询
    async queryData(page) {
      page && (this.pagination.page = page)
      const params = { ...this.pagination, ...this.conditions }
      this.loading = true
      const { data: { Rows, Total }} = await apiKastoreList(params)
      this.gridOptions.data = Rows
      this.pagination.totalCount = Total
      this.loading = false
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    resetQuery() {
      this.conditions = {
        shortName: '',
        fullName: ''
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        const selectData = this.$refs.gridOptions.getRadioRecord()
        resolve(selectData)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/KAStoreSelect.vue